import React from "react";
import Logo from "src/components/Logo";
import show1 from "./img/bg-showcase-1.jpg";
import show2 from "./img/bg-showcase-2.jpg";
import test1 from "./img/testimonials-1.jpg";
import test2 from "./img/testimonials-2.jpg";
import test3 from "./img/testimonials-3.jpg";


const LandingPage = () => {
  return (
    <div>
      <nav className="navbar navbar-light bg-light static-top">
        <div className="container">  
          <a className="navbar-brand" href="/"> 
            {<Logo></Logo>}
          </a>
          <a className="btn btn-primary" style={{backgroundColor:'#3F51B5',fontWeight:'bold'}} href="/login">
            Sign In
          </a>
        </div>
      </nav>

      <header className="masthead text-white text-center">
        <div className="overlay"></div>
        <div className="container">
        <div className="row">
        <div className="col-xl-9 mx-auto">
          <h1 className="mb-5" >Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h1>
        </div>
        <div className="col-md-10 col-lg-8 col-xl-7 mx-auto">
           
            <div className="form-row">
              <div className="col-12 col-md-6 mb-2 mb-md-0">
              <a className="btn btn-block btn-lg btn-warning" style={{color:'white', backgroundColor:'#3F51B5',fontWeight:'bold'}} href="/worker_registration">
                  Apply as worker!
                </a>              
              </div>

              <div className="col-12 col-md-6">
                  <a className="btn btn-block btn-lg btn-warning" style={{color:'#3F51B5',fontWeight:'bold'}} href="/work_request">
                  Request a work!
                </a>              
              </div>
            </div>          
        </div>
      </div>
        </div>
      </header>
      <section className="features-icons bg-light text-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div className="features-icons-icon d-flex">
                  <i className="icon-screen-desktop m-auto text-primary"></i>
                </div>
                <h3>Lorem Ipsum</h3>
                <p className="lead mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque venenatis orci eu urna facilisis sollicitudin.
                  Vestibulum molestie in diam quis egestas. In hac habitasse
                  platea dictumst. Vestibulum molestie ipsum quis nibh
                  scelerisque, id malesuada ex viverra
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
                <div className="features-icons-icon d-flex">
                  <i className="icon-layers m-auto text-primary"></i>
                </div>
                <h3>Lorem Ipsum</h3>
                <p className="lead mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque venenatis orci eu urna facilisis sollicitudin.{" "}
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="features-icons-item mx-auto mb-0 mb-lg-3">
                <div className="features-icons-icon d-flex">
                  <i className="icon-check m-auto text-primary"></i>
                </div>
                <h3>Lorem Ipsum</h3>
                <p className="lead mb-0">
                  RLorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque venenatis orci eu urna facilisis sollicitudin.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="showcase">
        <div className="container-fluid p-0">
          <div className="row no-gutters">
            <div className="col-lg-6 order-lg-2 text-white showcase-img">
              <img src={show1} alt="new" />
            </div>
            <div className="col-lg-6 order-lg-1 my-auto sh     sowcase-text">
              <h2>Lorem Ipsum</h2>
              <p className="lead mb-0">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Pellentesque venenatis orci eu urna facilisis sollicitudin.
                Vestibulum molestie in diam quis egestas. In hac habitasse
                platea dictumst. Vestibulum molestie ipsum quis nibh
                scelerisque, id malesuada ex viverra
              </p>
            </div>
          </div>
          <div className="row no-gutters">
            <div className="col-lg-6 text-white showcase-img">
              <img src={show2} alt="new" />
            </div>
            <div className="col-lg-6 my-auto showcase-text">
              <h2>Lorem Ipsum</h2>
              <p className="lead mb-0">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Pellentesque venenatis orci eu urna facilisis sollicitudin.
                Vestibulum molestie in diam quis egestas. In hac habitasse
                platea dictumst. Vestibulum molestie ipsum quis nibh
                scelerisque, id malesuada ex viverra
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials text-center bg-light">
        <div className="container">
          <h2 className="mb-5">What people are saying...</h2>
          <div className="row">
            <div className="col-lg-4">
              <div className="testimonial-item mx-auto mb-5 mb-lg-0">
                <img
                  className="img-fluid rounded-circle mb-3"
                  src={test1}
                  alt=""
                />
                <h5>Margaret E.</h5>
                <p className="font-weight-light mb-0">
                  "This is fantastic! Thanks so much guys!"
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="testimonial-item mx-auto mb-5 mb-lg-0">
                <img
                  className="img-fluid rounded-circle mb-3"
                  src={test2}
                  alt=""
                />
                <h5>Fred S.</h5>
                <p className="font-weight-light mb-0">
                  "Bootstrap is amazing. I've been using it to create lots of
                  super nice landing pages."
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="testimonial-item mx-auto mb-5 mb-lg-0">
                <img
                  className="img-fluid rounded-circle mb-3"
                  src={test3}
                  alt=""
                />
                <h5>Sarah W.</h5>
                <p className="font-weight-light mb-0">
                  "Thanks so much for making these free resources available to
                  us!"
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 h-100 text-center text-lg-left my-auto">
              <ul className="list-inline mb-2">
                <li className="list-inline-item">
                  <a style={{color:'#3F51B5'}} href="/">About</a>
                </li>
                <li className="list-inline-item">&sdot;</li>
                <li className="list-inline-item" >
                  <a style={{color:'#3F51B5'}} href="/">Contact</a>
                </li>
                <li className="list-inline-item">&sdot;</li>
                <li className="list-inline-item">
                  <a style={{color:'#3F51B5'}} href="/">Terms of Use</a>
                </li>
                <li className="list-inline-item">&sdot;</li>
                <li className="list-inline-item">
                  <a style={{color:'#3F51B5'}} href="/">Privacy Policy</a>
                </li>
              </ul>
              <p style={{color:'#3F51B5'}} className="text-muted small mb-4 mb-lg-0">
                &copy; Your Website 2020. All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-6 h-100 text-center text-lg-right my-auto">
              <ul className="list-inline mb-0">
                <li className="list-inline-item mr-3">
                  <a href="/">
                    <i className="fab fa-facebook fa-2x fa-fw"></i>
                  </a>
                </li>
                <li className="list-inline-item mr-3">
                  <a href="/">
                    <i className="fab fa-twitter-square fa-2x fa-fw"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="/">
                    <i className="fab fa-instagram fa-2x fa-fw"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
